import { postMessageToParent } from '../../post-message/postMessageToParent';
export const postMicButtonClickEvent = () => {
  postMessageToParent('external-api-event', {
    eventType: 'micButtonClick',
    timestamp: Date.now()
  });
};
export const postMicButtonStopEvent = () => {
  postMessageToParent('external-api-event', {
    eventType: 'micButtonStop',
    timestamp: Date.now()
  });
};